import {ComponentProps, ForwardedRef, forwardRef, ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

export interface TextInputProps extends ComponentProps<'input'> {
  ref?: ForwardedRef<HTMLInputElement>;
  icon?: ReactNode;
  value?: string;
  maskForRollbar?: boolean;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({className, icon, value, name, maskForRollbar, ...rest}, ref) => {
    if (icon) {
      return (
        <div
          className={twMerge(
            'flex w-full items-center gap-1 rounded-xl bg-white p-3',
            className
          )}
        >
          {icon}
          <input
            {...rest}
            ref={ref}
            name={name}
            className={twMerge(
              'w-full bg-white text-black focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
              maskForRollbar && 'rb-mask'
            )}
            value={value}
          />
        </div>
      );
    }

    return (
      <input
        {...rest}
        ref={ref}
        name={name}
        className={twMerge(
          'w-full rounded-xl bg-white p-3 text-black focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
          className,
          maskForRollbar && 'rb-mask'
        )}
        value={value}
      />
    );
  }
);

export default TextInput;
